import { authentication } from '@ecosystem/newron-client-lib';
import { CustomFeature, Entity } from '../types';

export const CACHE_SUFFIX = '_context_values_cache';

type ValueSet = Record<string, Entity[]>;

export async function store(
  name: string,
  settings: ValueSet,
  filters?: ValueSet,
  customFeature?: CustomFeature
): Promise<void> {
  const user = authentication.getUser();
  if (!user) {
    return;
  }

  /**Clear old cache entries since internal and external user keys are different.
   * internal user oauth2|gfk-aad|jDfHnrQ41065IDPLC/2tlA==:market_context_values_cache
   * external user auth0|663b72e454148f0472370861:market_context_values_cache
   */
  Object.keys(localStorage).forEach(key => {
    if (key.includes(CACHE_SUFFIX)) {
      localStorage.removeItem(key);
    }
  });

  localStorage.setItem(
    `${user.sub}:${name}${CACHE_SUFFIX}`,
    JSON.stringify({
      settings,
      filters,
      customFeature,
    })
  );
}

export async function retrieve(
  name: string
): Promise<{ settings: ValueSet; filters?: ValueSet; customFeature?: CustomFeature } | undefined> {
  const user = authentication.getUser();
  if (!user) {
    return;
  }

  const str = localStorage.getItem(`${user.sub}:${name}${CACHE_SUFFIX}`);
  if (!str) {
    return;
  }

  return JSON.parse(str);
}
